import * as echarts from 'echarts';
import { useEffect, useRef } from 'react';
import chinaMap from './geoData.json';
import { cloneDeep, merge } from 'lodash';
const chinaMapCopy = cloneDeep(chinaMap);
let initialMap = chinaMapCopy.features.map(ele => {
    return {
        name: ele.properties['name'],
        value: 0
    };
});
console.log(initialMap, 'initialMap');
const GrtEchartChinaMap = (props) => {
    let data = props.value.length ? props.value : initialMap;
    const chartRef = useRef(null);
    useEffect(() => {
        echarts.registerMap("china", chinaMap);
        let chartInstance = echarts.init(chartRef.current);
        let baseOption = {
            tooltip: {
                formatter: (params) => {
                    console.log(params, '哈哈');
                    if (params.data)
                        return params.name + '：' + params.data['value'];
                }
            },
            visualMap: {
                show: false,
                type: 'piecewise',
                text: ['', ''],
                showLabel: true,
                min: 0,
                pieces: [
                    { min: 10000 },
                    { min: 8000, max: 10000 },
                    { min: 5000, max: 8000 },
                    { min: 1000, max: 5000 },
                    { min: 0, max: 1000, },
                ],
                inRange: {
                    color: [
                        "rgb(239,243,255)",
                        "rgb(189,215,231)",
                        "rgb(107,174,214)",
                        "rgb(49,130,189)",
                        "rgb(8,81,156)"
                    ]
                },
            },
            series: {
                type: 'map',
                mapType: 'china',
                nameProperty: 'name',
                selectedMode: 'false',
                data: data
            }
        };
        let option = merge(baseOption, { ...props }, { ...props['customConfig'] });
        chartInstance.setOption(option);
    }, [props]);
    return (<div ref={chartRef} style={{ height: '100%', minHeight: '500px' }}></div>);
};
export default GrtEchartChinaMap;
